import {Map} from 'immutable'

const NetworkReducer = (state = Map(), action) => {
  const { type } = action;
  const matches = /(.*) (requested|succeeded|failed)/.exec(type);
  if (!matches) return state;
  const [, requestName, requestState] = matches;
//          'fetched': false,
//          'fetching': false,
//          'lastFetched': undefined,
//          'errorMsg': undefined,
//          'state': undefined
  state = state.update(requestName, (stateRequest)=> {
      if(stateRequest === undefined) stateRequest=Map({
          'fetched': false,
          'fetching': false,
          'lastFetched': undefined,
          'errorMsg': undefined,
          'state': undefined
      })

      stateRequest = stateRequest.set('state', requestState)
      switch (requestState) {
          case 'requested':
              return stateRequest.set('fetching', true)
          case 'succeeded':
              return stateRequest.set('fetched', true).set('lastFetched',  new Date().toLocaleString()).set('fetching', false)
          case 'failed':
          default:
              return stateRequest.set('errorMsg', action.error).set('fetched', true).set('fetching', false)
      }
  })
  return state
};

export default NetworkReducer;



// WEBPACK FOOTER //
// ./src/model/Network/reducer.js